export default (mapping, element) => {
	if (element instanceof Element) {
		const match = Object.entries(mapping).find(([_key, selector]) => {
			if (typeof selector === 'string') {
				return element.matches(selector);
			} else if (selector instanceof Array) {
				return selector.find((sel) => element.matches(sel));
			}
			return undefined;
		});
		return match ? match[0] : undefined;
	}
	return undefined;
};
